import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
import vueHeadful from "vue-headful";

Vue.component("vue-headful", vueHeadful);

Vue.config.productionTip = false;

new Vue({
  created() {
    AOS.init({ disable: window.innerWidth < 1030 });
  },
  router,
  render: h => h(App)
}).$mount("#app");
